<template>
<div  class=" container-fluid   overflow-auto pb-4 menu-margin-top"  >
  	<!-- Start the code for this screen here -->
	<div  class="llp-container-section">
    <nav class="navbar navbar-expand-lg  bg-info text-white">
       <span><b>{{headerMessage}}</b></span>
    </nav>
		<center><span :style="msgcolor"><b>{{message}}</b></span></center>
		<div class="container-fluid ">
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 ">
         <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
		      	<label id="prefixddlabel" class="col-form-label col-form-label-sm ">Prefix</label>
         </div><!--col end-->

      <div class="col-12 col-md-12 align-items-center">
			    <select id="prefixdd" v-model.trim="employee.selectedUserPrefixCode"  class="form-control input-sm" >
				      <option value="">Select a Prefix...</option>
				      <option v-for="(option, index) of userprefixs" :value="option.userPrefixC" :key="index">
					      {{ option.userPrefixX }}
				      </option>
		    	</select>
      </div><!--col end-->
     </div><!--row end-->
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
       <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			    <label id="fnamelabel" class="col-form-label col-form-label-sm required">First Name</label>
      </div><!--col end-->
			<div class="col-12 col-md-12 justify-content-end align-items-center mb-3 mb-lg-0 mb-md-3 mb-sm-3">

            <input id="fname"
				   placeholder="Enter First Name"
				   v-model.trim="employee.firstName"
				    class="form-control input-sm "
				                       v-validate="'required'"
                    data-vv-name="First Name"
				   onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190" />

         <div v-if="errors.has('First Name')" class="alert-danger"  >
                {{ errors.first('First Name') }}
             </div>
      </div><!--col end-->
      <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center ">
		      	<label id="mnamelabel" class="col-form-label col-form-label-sm">Middle Name</label>
      </div><!--col end-->
      <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
			      <input id="mname"
				   placeholder="Enter Middle Name"
				    class="form-control input-sm"
				   v-model.trim="employee.middleName"
				   onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
      </div><!--col end-->
      <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			      <label id="lnamelabel" class="col-form-label col-form-label-sm required">Last Name</label>
      </div><!--col end-->
			<div class="col-12 col-md-12  justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
             <input id="lname" class="form-control input-sm"
				   placeholder="Enter Last Name"

				   v-model.trim="employee.lastName"
				   v-validate="'required'"
                    data-vv-name="Last Name"
				   onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
         <div v-if="errors.has('Last Name')" class="alert-danger" > {{ errors.first('Last Name') }} </div>
      </div><!--col end-->

       </div><!--row end-->

      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
          <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			      <label id="adr1label" class="col-form-label col-form-label-sm required">Address Line1</label>
           </div><!--col end-->
		    	<div class="col-12 col-md-12  justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
             <input id="adr1"
                  placeholder="Enter Address1"
                  class="form-control input-sm"
                  v-model.trim="employee.addressLine1"
                  v-validate="'required'" data-vv-name="Address Line1"
                  maxlength="50"/>
                  <div v-if="errors.has('Address Line1')" class="alert-danger" > {{ errors.first('Address Line1') }} </div>
          </div><!--col end-->
          <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			        <label id="adr2label" class="col-form-label col-form-label-sm">Address Line2</label>
          </div><!--col end-->
          <div class="col-12 col-md-12  justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                <input id="adr2"
                    placeholder="Enter Address2"
                    class="form-control input-sm"
                    v-model.trim="employee.addressLine2"
                    maxlength="50"/>
          </div><!--col end-->
          <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			        <label id="citylabel" class="col-form-label col-form-label-sm required">City</label>
          </div><!--col end-->
		    	<div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input id="city"
                  placeholder="Enter City"
                  class="form-control input-sm"
                  v-model.trim="employee.city"
                  v-validate="'required'" data-vv-name="City"
                  maxlength="50"
                  onkeypress="return (event.charCode > 64 && event.charCode < 91) || (event.charCode > 96 && event.charCode < 123) || event.charCode = 32 || event.charCode = 188 || event.charCode = 190"/>
                  <div v-if="errors.has('City')" class="alert-danger" > {{ errors.first('City') }} </div>
          </div><!--col end-->

       </div><!--row end-->
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			            <label id="statesddlabel" class="col-form-label col-form-label-sm required" >State</label>
              </div><!--col end-->
		        	<div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                 <!-- <select id="statesdd"
                        v-model="employee.selectedStateCode"
                        class="form-control input-sm"
                        v-validate="'required'" data-vv-name="State"
                        >
                      <option value="">Select a State...</option>
                      <option v-for="(option,index) of states" :value="option.stateFipsC" :key="index">
                        {{ option.stateN }}
                      </option>
                    </select>-->
                     <multiselect
    style="width:100%; color: #777;"
    v-validate="'required'"
    data-vv-name="State"
    v-model="employee.selectedStateCode"
    :options="states"
    placeholder="Select a State..."
    :value="states.stateFipsC"
     label="stateN"
    selected="selected"
    class="state"
    id="statesdd">
  </multiselect>
                  <div v-if="errors.has('State')" class="alert-danger" > {{ errors.first('State') }} </div>
              </div><!--col end-->
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
		              	<label id="zipcodelabel" class="col-form-label col-form-label-sm required">Zip Code</label>
                </div><!--col end-->
			          <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input id="zipcode"
                        placeholder="Enter Zipcode"
                       class="form-control input-sm"
                        v-model="employee.zipCode"
                        @change="zipDecoder(employee.zipCode)"
                        title="Please enter 5 digits"
                        v-validate="{ required: true, regex: /^(\d)(?!\1+$)/, digits:5 }" data-vv-name="Zip Code"
                        maxlength="5"
                        onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))"/>
                        <div v-if="errors.has('Zip Code')" class="alert-danger" > {{ errors.first('Zip Code') }} </div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
          			      <label id="countrylabel" class="col-form-label col-form-label-sm">Country</label>
                </div><!--col end-->
                <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input id="country"
                    placeholder="Enter Country"
                   class="form-control input-sm"
                    v-model="employee.countryName"
                    disabled="true"/>
                 </div><!--col end-->
      </div><!--row end-->
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
             <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
			              <label id="emaillabel" class="col-form-label col-form-label-sm required">Email</label>
              </div><!--col end-->
              <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input id="email"
                        placeholder="Enter email"
                        class="form-control input-sm"
                        :disabled="isDisabled"
                        v-model.trim="employee.emailId"
                        v-validate="'required|email'" data-vv-name="Email" ref="emailref" />
                        <div v-if="errors.has('Email')" class="alert-danger" > {{ errors.first('Email') }} </div>
                </div><!--col end-->
                <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                      <label id="remaillabel" class="col-form-label col-form-label-sm required">Confirm Email</label>
                </div><!--col end-->
              <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                        <input id="remail"
                              placeholder="Confirm Email"
                              class="form-control input-sm"
                              :disabled="isDisabled"
                              v-model.trim="employee.confirmEmailId"
                              v-validate="'required|confirmed:emailref'"  data-vv-name="ReEnter Email"
                              />
                          <div v-if="errors.has('ReEnter Email')" class="alert-danger" > {{ errors.first('ReEnter Email') }} </div>
               </div><!--col end-->

      </div><!--row end-->
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">

          <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <label id="pnumlabel" class="col-form-label col-form-label-sm required">Cell Phone</label>
          </div><!--col end-->
          <div class="col-12 col-md-12  justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input id="pnum"
                        placeholder="Enter Mobile Number"
                        class="form-control input-sm"
                        v-model.trim="employee.mobileNumber"
                        v-validate="'required|min:10|max:14'" data-vv-name="Cell Phone"
                        pattern="[0-9]*"
                        @input="formatCellPhoneNumber" @blur="formatCellPhoneNumber"
                        title="Please enter 10 digits"
                        maxlength="10"/>
                        <div v-if="errors.has('Cell Phone')" class="alert-danger" > {{ errors.first('Cell Phone') }} </div>
            </div><!--col end-->
            <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <label id="wnumlabel" class="col-form-label col-form-label-sm">Work Phone</label>
            </div><!--col end-->
             <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input id="wnum"
                        placeholder="Enter Work Number"
                        v-model.trim="employee.workNumber"
                        title="Please enter 10 digits"
                        class="form-control input-sm"
                        maxlength="10"
                        v-validate="'min:10|max:14'" data-vv-name="Work Phone"
                        @input="formatWorkPhoneNumber" @blur="formatWorkPhoneNumber"
                        />
                        <div v-if="errors.has('Work Phone')" class="alert-danger" > {{ errors.first('Work Phone') }} </div>
              </div><!--col end-->
               <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                    <label id="fnumlabel" class="col-form-label col-form-label-sm">Fax #</label>
               </div><!--col end-->
               <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <input id="fnum"
                          placeholder="Enter Fax Number"
                        title="Please enter 10 digits"
                        class="form-control input-sm"
                        v-model.trim="employee.faxNumber"
                        maxlength="10"
                        v-validate="'min:10|max:14'" data-vv-name="Fax"
                              @input="formatFaxNumber"
                              @blur="formatFaxNumber"
                              />
                              <div v-if="errors.has('Fax')" class="alert-danger" > {{ errors.first('Fax') }} </div>
                </div><!--col end-->

      </div><!--row end-->
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2">
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                      <label id="preferredccddlabel" class="col-form-label col-form-label-sm">Preferred Contact</label>
              </div><!--col end-->
              <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <select id="preferredccdd"
                          v-model="employee.preferredContactCode"
                          class="form-control input-sm"
                          disabled="disabled">
                        <option v-for="(option,index) of preferredContactOptions" :value="option.value" :key="index">{{ option.text }}</option>
                      </select>
              </div><!--col end-->
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                      <label id="roleddlabel" class="col-form-label col-form-label-sm required">Role Type</label>
              </div><!--col end-->
              <div class="col-12 col-md-12  justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                      <!-- <select id="roledd" v-model="employee.roleType" v-validate="'required'" data-vv-name="Role Type" @[change]="displaySpecialAgentSection" class="form-control input-sm" >
                        <option value="">Select a Role...</option>
                        <option v-for="(option,index) of userroles" :value="option.userRoleC" :key="index">{{ option.userRoleX }}</option>
                      </select> -->
                      <!-- <multiselect
    style="width:100%; color: #777;"
    v-validate="'required'"
    data-vv-name="Role Type"
    v-model="employee.roleType"
    :options="userroles"
    placeholder="Select a Role..."
    :track-by="'userRoleC'"
     :label="'userRoleX'"
    selected="selected"
    :close-on-select="false"
    id="roledd"
    :multiple="true"
    class="employeeRole"
    >
  </multiselect> -->
  <div class="dropdownContainer">
    <b-dropdown id="dropdown-form" :text="''" 
     ref="dropdown" class="filterDropdown" toggle-class="dropdownToggle">
      <template #button-content>
          <div class="d-flex flex-wrap">
            <span v-if="selectedOptions.length === 0">Select Roles</span>
            <span v-for="(option, index) in selectedOptions" :key="index" class="chip">
              {{ option }}
              <b-button size="sm" class="ml-2 p-0 btnChip" @click.stop="removeOption(option)">
                &times;
              </b-button>
            </span>
          </div>
        </template>
      <b-form-checkbox @change="validateRoleType" v-for="(role, index) in userroles" v-model="employee.roleType" :value="role">{{ role.userRoleX }}</b-form-checkbox>
    </b-dropdown>
    
  </div>
                      <div v-if="roleTypeError" class="alert-danger" > {{ roleTypeError }} </div>
              </div><!--col end-->
              <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
                     <label id="statusddlabel" class="col-form-label col-form-label-sm">Status</label>
              </div><!--col end-->
              <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
                    <select id="statusdd" v-model="employee.selectedStatusCode" class="form-control input-sm" >
                      <option v-for="(option,index) in statusOptions" :value="option.value" :key="index">{{ option.text }}</option>
                    </select>
              </div><!--col end-->

      </div><!--row end-->

		  </div>

	  <br>
		<div id="specialagentsection" :style="showSpecialAgentSection">
			 <nav class="navbar navbar-expand-lg  bg-info text-white">
					<span>
						<b>Dealer Assignments</b>
					</span>
			</nav>

      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 row-cols-2 p-2 mr-0">
            <div class="col-12 col-md-12 d-flex justify-content-lg-end align-items-center">
				        <label id="saregionddlabel" class="col-form-label col-form-label-sm">Region</label>
            </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
            <select id="saregiondd" v-model="selectedregion" @[change]="populatedregionstates" class="form-control input-sm  mb-3 mb-lg-0 mb-md-3 mb-sm-3 " >
              <option value="">Select a Region...</option>
              <option v-for="(option,index) of regions" :value="option.regionC" :key="index">
                {{ option.regionX }}
              </option>
            </select>
        </div><!--col end-->
       <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
		      		<label id="sastatesddlabel" class="col-form-label col-form-label-sm">State</label>
        </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <select id="sastatesdd" v-model="selectedstate" @[change]="populatestatedealers"  class="form-control input-sm  mb-3 mb-lg-0 mb-md-3 mb-sm-3" >
                <option value="">Select a State...</option>
                <option v-for="(option,index) of fullstateslist" :value="option.dstateFip.stateFipsC" :key="index">
                  {{ option.dstateFip.stateN }}
                </option>
				</select><!--col end-->
        </div>
        <div class="col-12 col-md-12  d-flex justify-content-lg-end align-items-center">
		      		<label id="sadealersddlabel" class="col-form-label col-form-label-sm">Dealer</label>
        </div><!--col end-->
        <div class="col-12 col-md-12 justify-content-end align-items-center  mb-3 mb-lg-0 mb-md-3 mb-sm-3">
              <select id="sadealersdd" v-model="selecteddealer"  class="form-control input-sm  mb-3 mb-lg-0 mb-md-3 mb-sm-3" >
                <option value="">Select a Dealer...</option>
                <option v-for="(option,index) of dealers" :value="option.dealerId" :key="index">
                  {{ option.dealerName}}
                </option>
              </select>
        </div><!--col end-->
    </div><!--row end-->
    <center>
             <button type="button" @click="addDealerAssignment" class="btn btn-secondary">Add</button>&nbsp;&nbsp;&nbsp;
              <button type="button" @click="resetDealerAssignment" class="btn btn-secondary">Reset</button>
    </center>
       <div class="row  p-2">
          <div class="col align-items-center">
            <ul :style="showErrorsObject">
                 <li v-for="(error,index) of errorslist" class="alert alert-danger" :key="index">{{ error }}</li>
            </ul>
          </div><!--col end-->
       </div>    <!--row end-->
     <div class="row p-2 justify-content-center">
                <div class="col">
                  <div class="table-responsive table-responsive-sm">
                          <table  class="table table-sm table-bordered table-striped ">
                            <thead>
                              <tr  class="table-month-header-blue">
                            <th v-for="(dach,index) in dealerassignmentcolnames"  :key="index">{{ dach.value }}</th>
                      </tr>
                            </thead>
                            <tbody>
                      <tr v-for="(entry,index) of reviewlist" :key="index">
                            <td>{{entry.rownumber}}</td>
                            <td>{{entry.selectedRegionX}}</td>
                            <td>{{entry.selectedStateX}}</td>
                            <td>{{entry.selectedDealerX}}</td>
                            <td>
                              <button type="submit" class="btn btn-secondary"  @click="deleteDealerAssignment(entry.selectedStateC , entry.selectedDealerC)">Delete</button>
                            </td>
                      </tr>
                            </tbody>
                   </table>
             </div>
           </div><!--col end-->

     </div>		 <!--row end-->

		</div>
		<div :style="showAssignAgentGoalsSection">

			<br>
					 <nav class="navbar navbar-expand-lg  bg-info text-white"><span><b>Assigned Goals-{{this.currentYear}}</b></span></nav>
               <div class="row p-2 justify-content-center">
                   <div class="col">
                     <div class="table-responsive stable-responsive-sm">
                       <table class="table table-sm table-bordered table-striped small">
                        <thead>
                  <tr class="table-month-header-blue">
                     <th  colspan="2"></th>
                     <th  v-for="(m,index) in months" colspan="2"  :key="index">{{ m.value }}</th>
                  </tr>
				<tr class="table-primary">
					<th v-for="(col,index) in colheaders" :key="index"  v-if="col.value != 'State'">{{col.value}}</th>
				</tr>
         </thead>
         <tbody>
				<template v-for="(agtgoal,i) in agentgoals">
					<template v-for="(goal, j) in agtgoal.goals">
						<template v-for="(subcategory, k) in goal.goalSubCategory">
							<tr>
								<!--td v-if="j==0 && k == 0" :rowspan="agtgoal.span" class="table-month-td">{{(agtgoal.state==='NA' ? '' : agtgoal.state)}}</td-->
								<td v-if="k == 0" :rowspan="goal.goalSubCategory.length" class="table-month-td">{{goal.goalname}}</td>
								<td class="table-month-td">{{subcategory.name}}</td>
								<template v-for="(month) in subcategory.monthly">
									<td class="table-month-td colorblue">
                    <center>
										<input type="text"
                        :id="'weightage' + agtgoal.state +subcategory.name + month.monthName "
                        v-model="month.weightage"
                        size="1"
                        maxlength="3"
                        :disabled="month.disabled"
                        onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                    </center>
									</td>
									<td class="table-month-td colorgreen">
										  <center>
                      <input type="text"
                        :id="'expected' + agtgoal.state +subcategory.name + month.monthName "
                        v-model="month.expected"
                        size="1"
                        maxlength="3"
                        :disabled="month.disabled"
                        onkeypress="return !(event.charCode != 46 && event.charCode > 31 && (event.charCode < 48 || event.charCode > 57))">
                      </center>
									</td>
								</template>
							</tr>
						</template>
					</template>
				</template>
         </tbody>
				</table>
			</div>
                   </div>
			</div>
		</div>

			<center class="mb-3">
				        <button  type="button" @click="saveEmployeeData" class="btn btn-secondary">Save</button>&nbsp;&nbsp;&nbsp;
                <button  type="button" v-if="selectedEmployeeId !==''" @click="backEmployee" class="btn btn-secondary"  >Back</button>
			</center>
        <br/>
		</div>
  	<!-- End of the code for this screen here -->
</div>
</template>
<script>

import httpcommon from '../js/http-common.js'
import httpcommonzero from '../js/http-common-zero.js'
import httpemployee from '../js/http-employee.js'
import httpmanagesource from '../js/http-managesource.js'
import { bus } from '../main'
import { invalid } from 'moment'
import Multiselect from 'vue-multiselect'
export default {
  components: {
  },
  data () {
    return {
      message: '',
      headerMessage: 'Employee Demographics',
      requiredfieldcontent: '*',
      selectedEmployeeId: this.$store.state.employeeId,
      currentYear: new Date().getFullYear(),
      selectedregion: '',
      selectedstate: '',
      selecteddealer: '',
      selectedregiondesc: '',
      selectedstatedesc: '',
      selecteddealerdesc: '',
      statusOptions: [],
      agentgoals: [],
      dealerassignmentcolnames: [],
      months: [],
      colheaders: [],
      errorslist: [],
      userprefixs: [],
      states: [],
      userroles: [],
      regions: [],
      fullstateslist: [],
      dealers: [],
      reviewlist: [],
      preferredContactOptions: [],
      existingEmailIds: [],
      employee: this.emptyEmployeeObject(),
      roleTypeError: "",
      msgcolor: {
        color: 'black'
      },
      showErrorsObject: {
        color: 'red',
        display: 'none'
      },
      highlightobject: {
			   border: ''
      },
      showSpecialAgentSection: {
			   display: 'none'
      },
      showAssignAgentGoalsSection: {
        display: 'none'
      },

      rlhighlightobject: {
        border: ''
		   }
    }
  },
  methods: {
    zipDecoder (zipCode) {
      if (zipCode.length == 5) {
        httpcommon.get('/statefip/zipCode/' + zipCode)
          .then(response => {
            if (response.data.city != null) {
              this.employee.city = response.data.city
            } else {
              this.employee.city = ''
            }
            if (response.data.city != null) {
              this.getEmployeeStateDetails(response.data.state)
            } else {
              this.employee.selectedStateCode = ''
            }
          })

          .catch(e => { this.errorslist.push(e) })
      }
    },
    getEmployeeStateDetails (stateFipsC) {
      for (let i = 0; i < this.states.length; i++) {
        if (this.states[i].stateAlphaC == stateFipsC) {
          this.employee.selectedStateCode = this.states[i]
        }
      }
    },
    dynamicaRows: function () {
      let span
      for (let i = 0; i < this.agentgoals.length; i++) {
        span = 0
        for (let j = 0; j < this.agentgoals[i].goals.length; j++) {
          span += this.agentgoals[i].goals[j].goalSubCategory.length
        }
        this.agentgoals[i].span = span
      }
    },
    disableWGEXFileds: function (monthname) {
      var month_number
      switch (monthname) {
        case 'Jan':
          month_number = 0
          break
        case 'Feb':
          month_number = 1
          break
        case 'March':
          month_number = 2
          break
        case 'April':
          month_number = 3
          break
        case 'May':
          month_number = 4
          break
        case 'Jun':
          month_number = 5
          break
        case 'Jul':
          month_number = 6
          break
        case 'Aug':
          month_number = 7
          break
        case 'Sep':
          month_number = 8
          break
        case 'Oct':
          month_number = 9
          break
        case 'Nov':
          month_number = 10
          break
        case 'Dec':
          month_number = 11
          break
				 default:
          month_number = 99
      }
      if (month_number < new Date().getMonth()) {
        return true
      } else {
        return false
      }
    },
    getmonthnumber: function (monthname) {
      var month_number
      switch (monthname) {
        case 'Jan':
          month_number = 0
          break
        case 'Feb':
          month_number = 1
          break
        case 'March':
          month_number = 2
          break
        case 'April':
          month_number = 3
          break
        case 'May':
          month_number = 4
          break
        case 'June':
          month_number = 5
          break
        case 'Jul':
          month_number = 6
          break
        case 'Aug':
          month_number = 7
          break
        case 'Sep':
          month_number = 8
          break
        case 'Oct':
          month_number = 9
          break
        case 'Nov':
          month_number = 10
          break
        case 'Dec':
          month_number = 11
          break
				 default:
          month_number = 99
      }
      return month_number
    },
    getStateAlphaC (stateFipsC) {
      for (var i = 0; i < this.states.length; i++) {
        var stateobject = this.states[i]
        if (stateobject.stateFipsC == stateFipsC) {
          return stateobject.stateAlphaC
        }
      }
      return stateFipsC
    },
    formatPhoneDisplay (phone) {
      if (!phone) {
        return ''
      }
      return String(phone).replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/g, '($1) $2-$3')
    },
    formatPhoneDigits (phone) {
      if (!phone) {
        return ''
      }
      return String(phone).replace(/[^0-9]/g, '')
    },
    formatCellPhoneNumber: function (event) {
      this.employee.mobileNumber = this.formatPhoneDisplay(this.employee.mobileNumber)
    },
    formatWorkPhoneNumber: function (event) {
      this.employee.workNumber = this.formatPhoneDisplay(this.employee.workNumber)
    },
    formatFaxNumber: function (event) {
      this.employee.faxNumber = this.formatPhoneDisplay(this.employee.faxNumber)
    },
    emptyEmployeeObject () {
      return {
        message: '',
        selectedUserPrefixCode: '',
        firstName: '',
        middleName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        selectedStateCode: '',
        countryName: 'USA',
        zipCode: '',
        emailId: '',
        confirmEmailId: '',
        existingEmailId: '',
        workNumber: '',
        mobileNumber: '',
        faxNumber: '',
        preferredContactCode: 'A',
        roleType: [],
        selectedStatusCode: 'IA',
        businessCoverageAreas: [],
        employee_Assigned_Goals: []
      }
    },
    displaySpecialAgentSection: function () {
      var isRole = this.employee.roleType.find((userRole) => userRole.userRoleC == 'SR')
      // if (this.employee.roleType.length > 0 && this.employee.roleType[0].userRoleC == 'SR' || this.employee.roleType[0].userRoleC == 'AD') {
        if (isRole) {  
      this.showSpecialAgentSection.display = 'inline'
        // this.showAssignAgentGoalsSection.display = 'inline';// revisit this line if add employee does not work
        this.agentgoals = []
        this.constructFixedAgentGoals()
        httpcommonzero.get('/region/').then(response => (this.regions = response.data))
        httpcommon.get('/staticdata/months/').then(response => { this.months = response.data }).catch(e => { this.errorslist.push(e) })
        httpcommon.get('/staticdata/dacolumnnames/').then(response => { this.dealerassignmentcolnames = response.data }).catch(e => { this.errorslist.push(e) })
        httpcommon.get('/staticdata/gacolumnnames/').then(response => { this.colheaders = response.data }).catch(e => { this.errorslist.push(e) })
      } else {
        this.resetsalesrepData()
      }
    },
    resetsalesrepData: function () {
      this.showSpecialAgentSection.display = 'none'
      this.showAssignAgentGoalsSection.display = 'none'
      this.selectedregion = ''
      this.selectedstate = ''
      this.selecteddealer = ''
      this.selectedregiondesc = ''
      this.selectedstatedesc = ''
      this.selecteddealerdesc = ''
      this.reviewlist = []
      this.regions = []
      this.fullstateslist = []
      this.dealers = []
      this.errorslist = []
      this.agentgoals = []
      this.months = []
      this.dealerassignmentcolnames = []
      this.showErrorsObject.display = 'none'
    },
    resetDealerAssignment: function () {
      this.selectedregion = ''
      this.selectedstate = ''
      this.selecteddealer = ''
      this.reviewlist = []
      // this.regions=[];
      this.fullstateslist = []
      this.dealers = []
    },
    populatedregionstates: function () {
      this.selectedstate = ''
      this.selecteddealer = ''
      this.fullstateslist = []
      this.dealers = []
      if (this.selectedregion.length > 0) {
        httpcommon.get('/regionstates/' + this.selectedregion).then(response => (this.fullstateslist = response.data))
      }
    },
    populatestatedealers: function () {
      this.selecteddealer = ''
      this.dealers = []
      this.errorslist = []
      // httpdealer.get('/dealerinfo/dealerinfobystate/' + this.selectedstate).then(response => {
      httpmanagesource.get('/dealerlistbystate/' + this.selectedstate).then(response => {
        this.dealers = response.data

        if (this.dealers.length == 0) {
          this.errorslist.push('No Dealers found in selected State.')
          this.showErrorsObject.display = 'inline'
        } else {
          this.dealers.unshift({
            'dealerId': 'All',
            'dealerName': 'All'
          })
          this.errorslist = []
          this.showErrorsObject.display = 'none'
        }
      }).catch(e => {
        this.errorslist.push(e)
      })
    },
    addAllDealers: function () {
      if (!this.checkforduplicates() && this.selectedregion.length != 0 && this.selectedstate.length != 0 && this.selecteddealer.length != 0) {
        var rownum = 1
        if (this.reviewlist.length > 0) {
          rownum = this.reviewlist.length
        }
        this.errorslist = []
        this.showErrorsObject.display = 'none'
        for (var i = 0; i < this.regions.length; i++) {
          var regionobject = this.regions[i]
          if (regionobject.regionC == this.selectedregion) {
            this.selectedregiondesc = regionobject.regionX
          }
        }
        for (var i = 0; i < this.states.length; i++) {
          var stateobject = this.states[i]
          if (stateobject.stateFipsC == this.selectedstate) {
            this.selectedstatedesc = stateobject.stateN
          }
        }
        for (var i = 1; i < this.dealers.length; i++) {
          var existsAlready = false
          for (var j = 0; j < this.reviewlist.length; j++) {
            var reviewobject = this.reviewlist[j]
            if (reviewobject.selectedRegionC == this.selectedregion && reviewobject.selectedStateC == this.selectedstate && reviewobject.selectedDealerC == this.dealers[i].dealerId) {
              existsAlready = true
            }
          }
          if (existsAlready === false) {
            this.reviewlist.push({
              'rownumber': rownum++,
              'selectedRegionC': this.selectedregion,
              'selectedStateC': this.selectedstate,
              'selectedDealerC': this.dealers[i].dealerId,
              'selectedRegionX': this.selectedregiondesc,
              'selectedStateX': this.selectedstatedesc,
              'selectedDealerX': this.dealers[i].dealerName
            })
          }
        }
        this.showAssignAgentGoalsSection.display = 'inline'
        this.rlhighlightobject.border = 'none'
      }
    },
    addDealerAssignment: function (e) {
      if (this.selecteddealer.length != 0 && this.selecteddealer === 'All') {
        this.addAllDealers()
      } else {
        if (!this.checkforduplicates() && this.selectedregion.length != 0 && this.selectedstate.length != 0 && this.selecteddealer.length != 0) {
          var rownum = 0
          this.errorslist = []
          this.showErrorsObject.display = 'none'
          for (var i = 0; i < this.reviewlist.length; i++) {
            rownum = i + 1
            this.reviewlist[i].rownumber = rownum
          }
          for (var i = 0; i < this.regions.length; i++) {
            var regionobject = this.regions[i]
            if (regionobject.regionC == this.selectedregion) {
              this.selectedregiondesc = regionobject.regionX
            }
          }

          for (var i = 0; i < this.states.length; i++) {
            var stateobject = this.states[i]
            if (stateobject.stateFipsC == this.selectedstate) {
              this.selectedstatedesc = stateobject.stateN
            }
          }

          for (var i = 0; i < this.dealers.length; i++) {
            var dealerobject = this.dealers[i]
            if (dealerobject.dealerId == this.selecteddealer) {
              this.selecteddealerdesc = dealerobject.dealerName
            }
          }
          this.reviewlist.push({
            'rownumber': rownum + 1,
            'selectedRegionC': this.selectedregion,
            'selectedStateC': this.selectedstate,
            'selectedDealerC': this.selecteddealer,
            'selectedRegionX': this.selectedregiondesc,
            'selectedStateX': this.selectedstatedesc,
            'selectedDealerX': this.selecteddealerdesc
          })
          this.showAssignAgentGoalsSection.display = 'inline'
          this.rlhighlightobject.border = 'none'
          // dynamically construct AgentGoals
        /* if (!this.checkforduplicatesstates(this.getStateAlphaC(this.selectedstate))) {
          this.constructAssignGoals()
        } */
        } else {
          if (this.reviewlist.length == 0) {
            this.errorslist = []
            this.agentgoals = []
            this.errorslist.push('Add at least one Dealer Assignment.')
            this.showErrorsObject.display = 'inline'
            this.showAssignAgentGoalsSection.display = 'none'
          }
        }
      }
    },
    checkforduplicates: function () {
      for (var i = 0; i < this.reviewlist.length; i++) {
        var reviewobject = this.reviewlist[i]
        if (reviewobject.selectedRegionC == this.selectedregion && reviewobject.selectedStateC == this.selectedstate && reviewobject.selectedDealerC == this.selecteddealer) {
          return true
        }
      }
      return false
    },
    checkforduplicatesstates: function (stateCode) {
      for (var i = 0; i < this.agentgoals.length; i++) {
        var agentgoalobject = this.agentgoals[i]
        if (agentgoalobject.state == stateCode) {
          return true
        }
      }
      return false
    },
    deleteDealerAssignment: function (statecode, dealercode) {
      var tempreviewlst = []
      for (var i = 0; i < this.reviewlist.length; i++) {
        var reviewobject = this.reviewlist[i]
        if (reviewobject.selectedDealerC != dealercode) {
          tempreviewlst.push(reviewobject)
        }
      }
      this.reviewlist = []
      this.reviewlist = tempreviewlst
      for (var i = 0; i < this.reviewlist.length; i++) {
        this.reviewlist[i].rownumber = i + 1
      }

      if (this.reviewlist.length == 0) {
        // this.showAssignAgentGoalsSection.display='none';
        this.agentgoals = []
        this.constructFixedAgentGoals()
      } else {
        for (var i = 0; i < this.agentgoals.length; i++) {
          var agoal = this.agentgoals[i]
          if (agoal.state == this.getStateAlphaC(statecode)) {
            this.agentgoals.splice(i, 1)
          }
        }
        // this.constructAssignGoals();
        this.showAssignAgentGoalsSection.display = 'inline'
      }
      // this.showAssignAgentGoalsSection.display = 'inline';
    },
    retrieveDropdownsData: function () {
      httpcommon.get('/userprefix/').then(response => { this.userprefixs = response.data }).catch(e => { this.errorslist.push(e) }),
      httpcommon.get('/userrole/').then(response => { this.userroles = response.data }).catch(e => { this.errorslist.push(e) }),
      httpcommon.get('/statefip/').then(response => { this.states = response.data }).catch(e => { this.errorslist.push(e) }),
      httpcommon.get('/staticdata/preferredcontact/').then(response => { this.preferredContactOptions = response.data }).catch(e => { this.errorslist.push(e) }),
      httpcommon.get('/staticdata/status/').then(response => { this.statusOptions = response.data }).catch(e => { this.errorslist.push(e) }),
      httpcommonzero.get('/digitalcontactinfo/emailids/employee').then(response => { this.existingEmailIds = response.data }).catch(e => { this.errorslist.push(e) })
    },
    passExistingDatatoEmployeeObject (existingdata) {
      const contact = existingdata.digitalContactInfo || {}
      const address = existingdata.address || {}
      return {
        message: '',
        selectedUserPrefixCode: (existingdata.userPrefixC == null ? '' : existingdata.userPrefixC),
        firstName: existingdata.firstName,
        middleName: existingdata.middleName,
        lastName: existingdata.lastName,
        addressLine1: address.street1,
        addressLine2: address.street2,
        city: address.city,
        selectedStateCode: address.stateFipsC,
        countryName: 'USA',
        zipCode: address.zipCode,
        existingEmailId: contact.email,
        emailId: contact.email,
        confirmEmailId: contact.email,
        workNumber: this.formatPhoneDisplay(contact.workNumber),
        mobileNumber: this.formatPhoneDisplay(contact.mobileNumber),
        faxNumber: this.formatPhoneDisplay(contact.faxNumber),
        preferredContactCode: contact.preferredContact,
        roleType: existingdata.userRoles.map(userRole => {
        return this.userroles.find(role => role.userRoleC === userRole.userRoleC);
      }),
        selectedStatusCode: existingdata.inactiveD ? 'IA' : 'A',
        businessCoverageAreas: existingdata.empBusinessCoverageAreas,
        employee_Assigned_Goals: existingdata.employeeAssignedGoals
      }
    },
    retrieveEmployeeData () {
      httpcommon.get('/statefip/').then(response => { this.states = response.data }).catch(e => { this.errorslist.push(e) })
      httpemployee.get('/employee/' + parseInt(this.selectedEmployeeId)).then(response => {
				 for (var i = 0; i < response.data.length; i++) {
          var employeeobject = response.data[i]
          this.zipDecoder(response.data[i].address.zipCode)
          if (employeeobject.employeeId == this.selectedEmployeeId) {
            this.employee = this.passExistingDatatoEmployeeObject(employeeobject)
            // Following lines of code will be executed only for Sales Rep users.
            console.log(this.employee,'this.employee')
            // if (this.employee.roleType == 'SR') {
              var isRole = this.employee.roleType.find((userRole) => userRole.userRoleC == 'SR')
              console.log(this.employee.roleType,'isRole')
              if (isRole) {

              this.displaySpecialAgentSection()
              var numberofrows = 0
              for (var i = 0; i < this.employee.businessCoverageAreas.length; i++) {
                var empbuscovarea = this.employee.businessCoverageAreas[i]
                numberofrows = numberofrows + 1
                this.reviewlist.push({
                  'rownumber': numberofrows,
                  'selectedRegionC': empbuscovarea.id.regionC,
                  'selectedStateC': empbuscovarea.id.stateFipsC,
                  'selectedDealerC': empbuscovarea.id.dealerId,
                  'selectedRegionX': empbuscovarea.dregion.regionX,
                  'selectedStateX': empbuscovarea.dstateFip.stateN,
                  'selectedDealerX': empbuscovarea.ddealerInfo.dealerName
                })
              }
              // this.showAssignAgentGoalsSection.display = 'inline';
              // if(this.reviewlist.length>0){
              this.showAssignAgentGoalsSection.display = 'inline'
              // this.constructAssignGoals();
              // }

              var existingagentgoals = employeeobject.employeeAssignedGoals
              if (existingagentgoals.length > 0) {
                if (this.agentgoals.length > 0) {
                  this.agentgoals.forEach(agent_goal => {
                    var goals_list = agent_goal.goals
                    goals_list.forEach(agoal => {
                      var goalSubcats = agoal.goalSubCategory
                      goalSubcats.forEach(goalsubcat => {
                        goalsubcat.monthly.forEach(monthe => {
                          existingagentgoals.forEach(existingGoalobject => {
                            var frommonth = new Date(existingGoalobject.goalActiveFromMonth)
                            var monthnumber = frommonth.getMonth()

                            // var existing_statecode= (existingGoalobject.stateFipsC==null ? 'NA' : existingGoalobject.stateFipsC);
                            if ((existingGoalobject.goalSubCategoryC === goalsubcat.subcategorycode) && (this.getmonthnumber(monthe.monthName) === monthnumber)) { // && (existing_statecode===agent_goal.stateFipsCode)
                              monthe.goalId = existingGoalobject.goalId
                              monthe.weightage = existingGoalobject.weightagePct === 0 ? '' : existingGoalobject.weightagePct
                              monthe.expected = existingGoalobject.expectedCount === 0 ? '' : existingGoalobject.expectedCount
                            }
                          })
                        })
                      })
                    })
                  })
                }
              }
            }
          }
        }
      }).catch(e => { console.log(e) })
    },
    constructAssignGoals: function () {
      /* for (var i = 0; i < this.reviewlist.length; i++) {
        var reviewobject = this.reviewlist[i]
        if (!this.checkforduplicatesstates(this.getStateAlphaC(reviewobject.selectedStateC))) {
            this.agentgoals.unshift(this.constructAgentGoalObject(reviewobject.selectedStateC))
        }
      }; */
      this.agentgoals.unshift(this.constructAgentGoalObject(null))
      this.dynamicaRows()
    },
    constructAgentGoalObject (stateId) {
      return {
        // state: this.getStateAlphaC(stateId),
        // stateFipsCode:stateId,
        span: 0,
        goals: [
          {
            goalname: 'Dealer Transaction',
            goalcode: 'DTX',
            goalSubCategory: [
              {
                name: 'Quotes',
                subcategorycode: 'QT',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              },
              {
                name: 'Apps',
                subcategorycode: 'APS',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              },
              {
                name: 'Deals',
                subcategorycode: 'DLS',
                monthly: [
                  { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                  { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                  { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                  { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                  { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                  { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                  { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                  { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                  { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                  { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                  { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                  { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                ]
              }
            ]
          }
        ]
      }
    	},
    	constructFixedAgentGoals () {
      this.constructAssignGoals()
      this.agentgoals.push(
				 {
          // state: 'NA',
          // stateFipsCode:'NA',
					 span: 0,
					 goals: [
						 /* {
               goalname: 'Dealer Development',
               goalcode: 'DD',
							 goalSubCategory: [
								 {
                   name: 'Active Dealer Visits',
                   subcategorycode: 'ADV',
									 monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                },
                {
                  name: 'New Delar Visits',
                  subcategorycode: 'NDV',
                  monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                },
                {
                  name: 'Chip Program Enrollment',
                  subcategorycode: 'CPE',
                  monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId:'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                }
              ]
             }, */
						 {
              goalname: 'Dealer Goals',
              goalcode: 'DG',
							 goalSubCategory: [
								 {
                  name: 'Existing Dealer Visits',
                  subcategorycode: 'EDV',
									 monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                },
                {
                  name: 'New/Dormant Dealer Visits',
                  subcategorycode: 'NDDV',
                  monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                }
              ]
            },
            {
              goalname: 'Support Goals',
              goalcode: 'SG',
              goalSubCategory: [
                {
                  name: 'Events',
                  subcategorycode: 'ET',
                  monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                },
                {
                  name: 'Conferences/Auctions',
                  subcategorycode: 'COAU',
                  monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                },
                {
                  name: 'Deal Support',
                  subcategorycode: 'DSRT',
                  monthly: [
                    { monthName: 'Jan', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jan') },
                    { monthName: 'Feb', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Feb') },
                    { monthName: 'March', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('March') },
                    { monthName: 'April', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('April') },
                    { monthName: 'May', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('May') },
                    { monthName: 'June', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jun') },
                    { monthName: 'Jul', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Jul') },
                    { monthName: 'Aug', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Aug') },
                    { monthName: 'Sep', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Sep') },
                    { monthName: 'Oct', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Oct') },
                    { monthName: 'Nov', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Nov') },
                    { monthName: 'Dec', weightage: '', expected: '', goalId: 'NA', disabled: this.disableWGEXFileds('Dec') }
                  ]
                }
              ]
            }
          ]
        }
       		)
    },
    backEmployee: function () {
      this.$emit('modifiedEmployee', 'All')
    },
    validateRoleType() {
      if (this.selectedOptions.length === 0) {
        this.roleTypeError = "The Role Type field is required.";
      } else {
        this.roleTypeError = "";
      }
    },
    saveEmployeeData: function () {
      this.validateRoleType()
      this.$validator.validateAll().then((isValid) => {
        if (!this.errors.any()) {
          this.validateData()
          
          if (this.errorslist.length == 0 && this.emailIdNotInTheSystem() && this.roleTypeError === "") {
            if (!this.selectedEmployeeId) {
              this.createNewEmpployeeData()
            } else {
              this.updateEmployeeData()
              setTimeout(() => this.$emit('modifiedEmployee', 'All'), 2000)
            }
          }
        }
      })
    },
    emailIdNotInTheSystem () {
      if (this.employee.emailId.length > 0 && this.isNewEmailIdCaptured()) {
        for (var i = 0; i < this.existingEmailIds.length; i++) {
          var obj = this.existingEmailIds[i]
          if (obj.email == this.employee.emailId) {
            this.message = 'Email already exists. Please choose a different email id.'
            this.msgcolor.color = 'Red'
            this.$validator.flag('Email', {
              valid: false,
              invalid: true
            })
            this.$validator.flag('ReEnter Email', {
              valid: false,
              invalid: true
            })
            return false
          }
        }
      }
      this.message = ''
      return true
    },
    isNewEmailIdCaptured () {
      if (this.employee.existingEmailId == this.employee.emailId) {
        return false
      } else {
        return true
      }
    },
    createNewEmpployeeData: function () {
      let newEmployee = this.createEmployeeObject()
      httpemployee.post('/employee/', newEmployee).then(response => {
        var employee = response.data
        if (employee.apiStatusMessage == 'CREATED') {
          this.employee = this.emptyEmployeeObject()
          this.message = 'Employee Successfully added into the system'
          this.msgcolor.color = 'Blue'
          if (newEmployee.userRoleC == 'SR') {
            this.resetsalesrepData()
          }
        } else if (employee.apiStatusMessage != 'CREATED') {
          this.message = employee.apiStatusMessage
          this.msgcolor.color = 'Red'
        }
      }).catch(e => {
        this.message = e
        this.msgcolor.color = 'Red'
      })
    },
    updateEmployeeData: function () {
      let newEmployee = this.createEmployeeObject()
      httpemployee.put('/employee/', newEmployee).then(response => {
        var empobj = response.data
        if (empobj.apiStatusMessage == 'UPDATED') {
          this.employee = this.emptyEmployeeObject()
          this.message = 'Employee Successfully updated into the system'
          this.msgcolor.color = 'Blue'
          if (newEmployee.userRoleC == 'SR') {
            this.resetsalesrepData()
          }
        } else if (empobj.apiStatusMessage != 'UPDATED') {
          this.message = empobj.apiStatusMessage
          this.msgcolor.color = 'Red'
        }
        this.$store.state.employeeId = ''
      }).catch(e => {
        this.message = e
        this.msgcolor.color = 'Red'
        this.$store.state.employeeId = ''
      })
    },
    createEmployeeObject () {
      var date = new Date()
      var currentDate = new Date()
      return {
        'employeeId': !this.selectedEmployeeId ? null : this.selectedEmployeeId,
        'firstName': this.employee.firstName,
        'middleName': this.employee.middleName,
        'lastName': this.employee.lastName,
        'userRoleC': this.employee.roleType[0].userRoleC,
        'userPrefixC': (this.employee.selectedUserPrefixCode.length == 0 ? null : this.employee.selectedUserPrefixCode),
        'userRoles':this.employee.roleType.map(role => ({ userRoleC: role.userRoleC })),
        'address': {
          'street1': this.employee.addressLine1,
          'street2': this.employee.addressLine2,
          'city': this.employee.city,
          'zipCode': this.employee.zipCode,
          'stateFipsC': this.employee.selectedStateCode.stateFipsC,
          'country': this.employee.countryName,
          'addressType': null,
          'inactiveD': this.employee.selectedStatusCode == 'A' ? null : currentDate,
          'creationD': currentDate,
          'creationUserI': this.$session.get('user_id'),
          'lastUpdatedD': !this.selectedEmployeeId ? null : currentDate,
          'lastUpdatedUserI': !this.selectedEmployeeId ? null : this.$session.get('user_id')
        },
        'digitalContactInfo': {
          'email': this.employee.emailId,
          'faxNumber': this.formatPhoneDigits(this.employee.faxNumber),
          'mobileNumber': this.formatPhoneDigits(this.employee.mobileNumber),
          'preferredContact': this.employee.preferredContactCode,
          'workNumber': this.formatPhoneDigits(this.employee.workNumber)
        },
        'empBusinessCoverageAreas': this.constructEmpBusCovAreaObject(currentDate),
        'employeeAssignedGoals': this.constructEmpAssignedGoalsObject(currentDate),
        'inactiveD': this.employee.selectedStatusCode == 'A' ? null : currentDate,
        'creationD': currentDate,
        'creationUserI': this.$session.get('user_id'),
        'lastUpdatedD': !this.selectedEmployeeId ? null : currentDate,
        'lastUpdatedUserI': !this.selectedEmployeeId ? null : this.$session.get('user_id')
      }
    }, // end of createEmployeeObject function
    constructEmpBusCovAreaObject: function (currentDate) {
      var ebcrlist = []
      for (var i = 0; i < this.reviewlist.length; i++) {
        var reviewobject = this.reviewlist[i]
        ebcrlist.push({
          'inactiveD': null,
          'creationD': currentDate,
          'creationUserI': this.$session.get('user_id'),
          'lastUpdatedD': !this.selectedEmployeeId ? null : currentDate,
          'lastUpdatedUserI': !this.selectedEmployeeId ? null : this.$session.get('user_id'),
          'id': {
            'employeeId': !this.selectedEmployeeId ? null : this.selectedEmployeeId,
            'regionC': reviewobject.selectedRegionC,
            'stateFipsC': reviewobject.selectedStateC,
            'dealerId': reviewobject.selectedDealerC
          }
        })
      }
      return ebcrlist
    }, // end of constructEmpBusCovAreaObject
    constructEmpAssignedGoalsObject: function (currentDate) {
      var date = new Date()
      var eaglist = []
      this.agentgoals.forEach(agent_goal => {
        var goals_list = agent_goal.goals
        goals_list.forEach(agoal => {
          var goalSubcats = agoal.goalSubCategory
          goalSubcats.forEach(goalsubcat => {
            goalsubcat.monthly.forEach(monthe => {
              if (!monthe.disabled && (monthe.weightage != '' || monthe.expected != '')) {
                if (monthe.goalId != 'NA') {
                  var empagentgoalfinalObject = {
                    'inactiveD': null,
                    'creationD': currentDate,
                    'creationUserI': this.$session.get('user_id'),
                    'lastUpdatedD': currentDate,
                    'lastUpdatedUserI': this.$session.get('user_id'),
                    'goalId': monthe.goalId,
                    'employeeId': !this.selectedEmployeeId ? null : this.selectedEmployeeId,
                    'goalCategoryC': agoal.goalcode,
                    'stateFipsC': (agent_goal.stateFipsCode === 'NA' ? null : agent_goal.stateFipsCode),
                    'goalSubCategoryC': goalsubcat.subcategorycode,
                    'goalActiveFromMonth': new Date(date.getFullYear(), (this.getmonthnumber(monthe.monthName)), 1, 12, 0, 0, 0),
                    'weightagePct': monthe.weightage,
                    'expectedCount': monthe.expected
                  }
                  eaglist.push(empagentgoalfinalObject)
                } else {
                  var empagentgoalfinalObject = {
                    'inactiveD': null,
                    'creationD': currentDate,
                    'creationUserI': this.$session.get('user_id'),
                    'lastUpdatedD': null,
                    'lastUpdatedUserI': null,
                    'goalId': null,
                    'employeeId': !this.selectedEmployeeId ? null : this.selectedEmployeeId,
                    'goalCategoryC': agoal.goalcode,
                    'stateFipsC': (agent_goal.stateFipsCode === 'NA' ? null : agent_goal.stateFipsCode),
                    'goalSubCategoryC': goalsubcat.subcategorycode,
                    'goalActiveFromMonth': new Date(date.getFullYear(), (this.getmonthnumber(monthe.monthName)), 1, 12, 0, 0, 0),
                    'weightagePct': monthe.weightage,
                    'expectedCount': monthe.expected
                  }
                  eaglist.push(empagentgoalfinalObject)
                }// end of if-else condition
              }
            })
          })
        })
      })
      return eaglist
    }, // end of constructEmpAssignedGoalsObject
    validateData: function () {
      this.errorslist = []

      // validating mandatory field Email id
      if (this.employee.emailId.includes('@luxuryleasepartners.com') || this.employee.emailId.includes('@unifiedinfotech.net') || this.employee.emailId.includes('@llp.finance') || this.employee.emailId.includes('@dupontregistry.com')) {
        this.message = ''
        this.msgcolor.color = ''
      } else {
        this.errorslist.push('email must be @luxuryleasepartners.com or @unifiedinfotech.net or @llp.finance or @dupontregistry.com!')
        this.message = 'Email Ids must contain @luxuryleasepartners.com or @unifiedinfotech.net or @llp.finance or @dupontregistry.com domain name!'
        this.msgcolor.color = 'Red'
        this.$validator.flag('Email', {
          valid: false,
          invalid: true
        })
        this.$validator.flag('ReEnter Email', {
          valid: false,
          invalid: true
        })
      }
    },
    removeOption(option) {
    this.employee.roleType = this.employee.roleType.filter(role=> role.userRoleX != option)
      // const key = Object.keys(this.filterOptions).find(key => this.formatOptionLabel(key) === option);
      // if (key) {
      //   this.filterOptions[key] = false;
      // }
      this.validateRoleType()
    },
  },
  mounted () {
    this.retrieveDropdownsData()
    this.selectedEmployeeId = this.$store.state.employeeId
    if (this.selectedEmployeeId > 0) {
      this.retrieveEmployeeData()
    }
    this.$store.state.employeeId = ''
  },
  computed: {
  	isDisabled: function () {
    	return (this.selectedEmployeeId > 0)
    },
    selectedOptions() {
      return this.employee.roleType.map(role => role.userRoleX )
      // console.log(this.employee.roleType,'this.employee.roleType')
      // return Object.keys(this.employee.roleType)
      //   .filter(key => this.employee.roleType[key])
    }
  }
}
</script>
<style scoped>
.wrap-text {
  white-space: nowrap;
}
 ::v-deep(.multiselect){
    font-size: 11px !important; /* Reduces font size for the whole component */
}
 ::v-deep(.multiselect__tags) {
  padding-top: 0px !important;
    padding-right: 35px !important; /* Reduces padding for tags */
    font-size: 12px !important; /* Decreases font size of selected tags */
}
::v-deep .multiselect__tag {
  margin: 0 !important;
}

::v-deep .multiselect__placeholder {
    margin-bottom: 0;
    padding-top: 11px;
}
 
::v-deep .multiselect__option{
    line-height: 1.2;
}
::v-deep .multiselect__option:after {
    top: 7px;
}
.dropdownContainer {
  width: 100%;
}
.b-dropdown {
  min-height: 32px;
  height: auto;
  max-height: 60px;
}
 .filterDropdown ::v-deep .dropdown-toggle  {
  border-radius: 8px !important;
  border-color: #BAC1C8;
  background-color: #FFFFFF !important;
  color: #8A8A8A;
  font-weight: 400;
  font-size: 12px;
  line-height: 32px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: start;
  padding: 0px 0px 0px 12px;
}
.filterDropdown ::v-deep .dropdown-toggle::after {
  position: absolute;
  top: 15px;
  right: 13px;
}
.filterDropdown ::v-deep .dropdown-menu {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  min-width: 14rem !important;
  border: none;
  /* border-radius: 8px; */
  box-shadow: -4px 6px 25.6px 0px #00000021;
  padding: 12px 8px 12px 8px;
  z-index: 1;
  max-height: 370px !important;
  overflow-y: scroll;
  text-wrap: nowrap;
}
.filterDropdown ::v-deep .custom-control {
padding: 16px 12px 16px 12px;
}
.filterDropdown ::v-deep .custom-control-input {
  position: relative;
}
/* .filterDropdown ::v-deep .custom-control:hover {
  background-color:#dbdbdb;
} */
.filterDropdown ::v-deep .custom-control-label {
  padding-left: 16px !important;
  color: #000000;
  font-weight: 600;
  font-size: 16px;
}
.filterDropdown {
  width: 100%;
}

.dropdownToggle {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.chip {
  display: flex;
  align-items: center;
  background-color: #e1e1e1;
  border-radius: 12px;
  padding-left: 8px;
  /* padding: 2px 8px; */
  margin-right: 4px;
  margin-bottom: 4px;
  margin-top: 4px;
  font-size: 10px;
  height: 22px;
  width: auto;
  max-width: 100px;
}

 .chip btn-outline-danger  {
  font-size: 12px !important;
  margin-left: 4px;
  padding: 0;
  color: #000000 !important;
  background: none !important;
  border: none;
  height: 20px !important;
}
.chip btn-outline-danger:hover {
  background-color: none !important;
}
.chip-remove:hover {
  color: #333; /* Darker color on hover */
  background-color: transparent !important; /* Ensure no background color */
  border-radius: 50%; /* Circular button */
}
.btnChip {
  background-color: transparent !important;
  color:#000000;
  border: none;
  margin-right: 0.5rem;
  padding-bottom: 3px !important;
}
.state ::v-deep .multiselect__input{
    height: 38px;
    margin: 0;
}
.state ::v-deep .multiselect__single{
    vertical-align: middle;
    margin: 0;
    padding: 0;
    line-height: 38px;
}
 

</style>
